import request from '@/config/axios'
import { merchantApi } from '@/config/axios'
import { supplierApi } from '@/api/mall/product/supplierPortal'

/** A 端 */
export const getAdminSettlePreviewSummary = (params: any) => {
  return request.get({ url: '/trade/supplier-settle-preview/summary', params })
}
export const getAdminSettlePreviewPage = (params: any) => {
  return request.get({ url: '/trade/supplier-settle-preview/page', params })
}

/** B 端 */
export const getMerchantSettlePreviewSummary = (params: any) => {
  return merchantApi.get({ url: '/merchant-api/trade/supplier-settle-preview/summary', params })
}
export const getMerchantSettlePreviewPage = (params: any) => {
  return merchantApi.get({ url: '/merchant-api/trade/supplier-settle-preview/page', params })
}

/** S 端 */
export const getSupplierSettlePreviewSummary = (params: any) => {
  return supplierApi.get({ url: '/supplier-api/trade/supplier-settle-preview/summary', params })
}
export const getSupplierSettlePreviewPage = (params: any) => {
  return supplierApi.get({ url: '/supplier-api/trade/supplier-settle-preview/page', params })
}
